import { render, staticRenderFns } from "./SignUpResultForPromote.vue?vue&type=template&id=38febe47"
import script from "./SignUpResultForPromote.vue?vue&type=script&lang=js"
export * from "./SignUpResultForPromote.vue?vue&type=script&lang=js"
import style0 from "./SignUpResultForPromote.vue?vue&type=style&index=0&id=38febe47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports